import {
    fetch,
    post
} from "@/util/http";

export default {
    // 获取订单列表
    getOrdersListAction({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            payload.options.random = Math.ceil(Math.random() * 100000);
            if (payload.options.dest.length > 0) {
                commit("changeEscSearchIcon", true);
            } else {
                commit("changeEscSearchIcon", false);
            }
            fetch("ecla/orders/", payload.options).then(
                res => {
                    state.ordersList = res.results;
                    state.isLoading = false;
                    resolve(res.results);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    getOrdersListAction2({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            payload.options.random = Math.ceil(Math.random() * 100000);
            if (payload.options.dest.length > 0) {
                commit("changeEscSearchIcon", true);
            } else {
                commit("changeEscSearchIcon", false);
            }
            fetch("ecla/contact_orders/", payload.options).then(
                res => {
                    state.ordersList = res.results;
                    console.log('in getOrdersListAction2 res.count=' + res.count)
                    state.totalOrderCount = res.count
                    state.isLoading = false;
                    resolve(res.results);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取订单详情
    getDetailsListAction({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            if (payload.options.dest.length > 0) {
                commit("changeEscSearchIcon", true);
            } else {
                commit("changeEscSearchIcon", false);
            }
            fetch(`pcib/auth_sn/${payload.orderId}/`, payload.options).then(
                res => {
                    state.detailsList = res.results;
                    state.isLoading = false;
                    state.detailsListCount = res.count;
                    resolve(res.results);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取联系人列表
    getContactsListAction({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            if (payload.options.dest.length > 0) {
                commit("changeEscSearchIcon", true);
            } else {
                commit("changeEscSearchIcon", false);
            }
            fetch("ecla/contacts/", payload.options).then(
                res => {
                    state.contactsList = res.results;
                    state.isLoading = false;
                    resolve(res.results);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取联系人列表
    getContactsListAction2({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            if (payload.options.dest.length > 0) {
                commit("changeEscSearchIcon", true);
            } else {
                commit("changeEscSearchIcon", false);
            }
            fetch("ecla/orders_contact/", payload.options).then(
                res => {
                    state.contactsList = res.results;
                    state.isLoading = false;
                    resolve(res.results);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取可分享列表
    getShareableContactsListAction({
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            fetch(`ecla/contacts_custom/${payload.order_id}/`).then(
                res => {
                    console.log("getShareableContactsListAction", res);
                    state.shareableContactsList = res;
                    state.isLoading = false;
                    resolve(res);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取可分享列表
    getShareableContactsListAction2({
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            fetch(`ecla/order_contacts_custom/${payload.order_id}/`).then(
                res => {
                    console.log("getShareableContactsListAction", res);
                    state.shareableContactsList = res;
                    state.isLoading = false;
                    resolve(res);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取以分享列表
    getSharedContactsListAction({
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            fetch(`ecla/share_contacts/${payload.order_id}/`).then(
                res => {
                    state.sharedContactsList = [];
                    res.forEach(item => {
                        state.sharedContactsList.push({
                            id: item.id,
                            username: item.user.username
                        });
                    });
                    state.isLoading = false;
                    resolve(state.sharedContactsList);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    // 获取以分享列表
    getSharedContactsListAction2({
        state
    }, payload) {
        return new Promise((resolve, reject) => {
            state.isLoading = true;
            fetch(`ecla/share_order_contacts/${payload.order_id}/`).then(
                res => {
                    state.sharedContactsList = res || [];
                    // res.forEach(item => {
                    //     state.sharedContactsList.push({
                    //         id: item.id,
                    //         username: item.username
                    //     });
                    // });
                    state.isLoading = false;
                    // resolve(state.sharedContactsList);
                    resolve(res);
                },
                err => {
                    state.isLoading = false;
                    reject(err);
                }
            );
        });
    },

    getToolsClassifyListAction({
        state
    }, payload) {
        return fetch(`download/tool/classifyList/`).then(
            res => {
                state.toolsClassifyList = res || [];
                return res;
            }
        );
    }
};



// WEBPACK FOOTER //
// ./src/store/config/actions.js